import React, {Component} from "react";
import BarTitle from "../../components/BarTitle";
import Painel from "../../components/Painel";
import Modal from "react-modal";
import './style.css'
import './loading.css'
import IntlCurrencyInput from "react-intl-currency-input";
import {  toast } from 'react-toastify';
import axios from "axios";
import QRCode from "react-qr-code";
import {CopyToClipboard} from "react-copy-to-clipboard";
import swal from "sweetalert";
import constants from "../../constants";



const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

function DivBoletoResult(props)
{
    const returnTransaction = props.result;
    return (
        <div className="col-12">
            <div className="row justify-content-center align-items-center text-center">
                <div className="col-12 fw-bold mb-2 text-center h3 mb-3">Dados para Pagamento</div>
                <div className="col-12 mb-2 text-center mb-3">
                    <a href={returnTransaction.link} target="_blank" className="btn btn-primary">Abrir Fatura</a>
                </div>
                <div className="col-12 fw-bold text-center h4 mb-3">Linha digitável</div>
                <p>{returnTransaction.linhaDigitavel}</p>
                <div className="col-12 mb-2">
                    <CopyToClipboard text={returnTransaction.linhaDigitavel}
                                     onCopy={() =>  toast.success('Copiado')}>
                        <button className="btn btn-outline-secondary" >Copiar Linha Digitável</button>
                    </CopyToClipboard>
                </div>
            </div>
        </div>
    )
}

function DivPixResult(props)
{
    const returnTransaction = props.result;
    const action = props.action;
    return (
        <div className="col-12">
            <div className="row justify-content-center align-items-center text-center">
                <div className="h3 text-center mb-3">Dados para Pagamento</div>
                <div className="col-12 fw-bold text-center mb-3">QRCODE</div>
                <QRCode
                    size={150}
                    style={{height: "auto", maxWidth: "150px", width: "150px"}}
                    value={returnTransaction.qrcode}
                    viewBox={`0 0 256 256`}
                />
                <div className="col-12 mb-2 text-center mt-3">
                    <CopyToClipboard text={returnTransaction.qrcode}
                                     onCopy={() => toast.success('Copiado')}>
                        <button className="btn btn-outline-secondary">Copiar código do PIX</button>
                    </CopyToClipboard>

                    <button className='btn btn-block btn-danger mt-3' onClick={action}>Cancelar</button>
                </div>
            </div>
        </div>
    )
}

function DivSuccessPaymentPix()
{
    return (
        <div className="row justify-content-center align-items-center">
            <div className="col-12 text-center my-3">
                <img alt={'Icon de confirmação'} src={'confirm.svg'}/>
            </div>

            <div className="col-12 text-center py-3">
                <div className="h2 mt-2">
                    Seu pagamento foi confirmado com sucesso!
                </div>
                <div className="h3 mt-3">
                    Seu saldo foi adicionado com sucesso
                </div>
            </div>
        </div>
    );
}

function DivCancelPaymentPix()
{
    return (
        <div className="row justify-content-center align-items-center">
            <div className="col-12 text-center py-3">
                <div className="h2 mt-2">
                    Sua fatura foi cancelada!
                </div>
            </div>
        </div>
    );
}

function DivLoading()
{
    return (
        <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}


class Wallet extends Component {
    baseUrl = '';
    token = 'token';
    establishmentName = 'name';
    establishmentId = '';

    historicTransactions = [];

    returnTransaction = '';

    uniqueId = '';
    divResult = '';

    pageSize = 10;
    page = 1;
    totalItems = 0;
    interval$ = null;

    isSuperUser = false;
    clientHttp= axios.create({
        httpsAgent: {rejectUnauthorized: false},
    })

    constructor(props)
    {
        super(props)

        //STATES
        this.state = {
            modalIsOpen: false,
            modalCashManualIsOpen: false,
            modalPaymentIsOpen: false,
            modalRequestTransferIsOpen: false,
            modalInfoWithdrawal: false,
            modalDetailsTransaction: false,
            RequestTransfer: false,
            value: 0,
            valueManual: 0,
            merchantManual: 0,
            descriptionManual: '',
            merchants: [],
            valueRequestWithdrawal: 0,
            paymentType: 'pix',
            balance: 0,
            historicTransactions: [],
            returnTransaction: [],
            listRequestWithdrawal: [],
            copied: false,
            pagination: {
                page: 1,
                pageSize: 10,
                pageCount: 0,
                totalItems: 0
            },
            loading: false,
            canClose: true,
            detailsTransaction: {}
        };

        this.baseUrl = constants().URL_API;
        this.isSuperUser = localStorage.getItem('is_super_user');
        //GET LOCAL INFORMATION
        this.token = localStorage.getItem('token');
        this.establishmentName = localStorage.getItem('establishment_name');
        this.establishmentId = localStorage.getItem('id_establishment');



        //FUNCTIONS BIND
        this.clearVarsCreateTransaction = this.clearVarsCreateTransaction.bind(this);
        this.clearDetailsTransaction = this.clearDetailsTransaction.bind(this);
        this.clearInfoCashManual = this.clearInfoCashManual.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleModalCashManual = this.toggleModalCashManual.bind(this);
        this.toggleModalRequestTransfer = this.toggleModalRequestTransfer.bind(this);
        this.toggleModalPayment = this.toggleModalPayment.bind(this);
        this.toggleModalInfoWithdrawal = this.toggleModalInfoWithdrawal.bind(this);
        this.toggleModalDetailsTransaction = this.toggleModalDetailsTransaction.bind(this);
        this.changePaymentType = this.changePaymentType.bind(this);
        this.changeValuePayment = this.changeValuePayment.bind(this);
        this.changeValuePaymentManual = this.changeValuePaymentManual.bind(this);
        this.changeValueRequestWithdrawal = this.changeValueRequestWithdrawal.bind(this);
        this.changeDescriptionManual = this.changeDescriptionManual.bind(this);
        this.createTransaction = this.createTransaction.bind(this);
        this.createTransactionManual = this.createTransactionManual.bind(this);
        this.cancelTransactionPix = this.cancelTransactionPix.bind(this);
        this.getDetailsTransaction = this.getDetailsTransaction.bind(this);
        this.requestWithdrawal = this.requestWithdrawal.bind(this);
        this.getRequestWithdrawal = this.getRequestWithdrawal.bind(this);
        this.finishPaymentWithdrawal = this.finishPaymentWithdrawal.bind(this);

        this.loadHistoricTransaction = this.loadHistoricTransaction.bind(this);

        this.getMerchants = this.getMerchants.bind(this);
        this.selectMerchant = this.selectMerchant.bind(this);
        this.InputMerchants= this.InputMerchants.bind(this);
    }

    //LIFECYCLE FUNCTIONS
    componentDidMount()
    {
        this.getWallet();
        this.getHistoricTransactions();
    }

    //FUNCTIONS FORMATE
    currencyFormat(num)
    {
        num = Number(num);
        return 'R$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    formatDate(date)
    {
        const _date = new Date(date);
        return _date.toLocaleDateString() + ' ' + _date.toLocaleTimeString();
    }

    clearDetailsTransaction()
    {
        this.returnTransaction = {};
        this.divResult = '';
        this.setState({detailsTransaction: {}})
        this.setState({returnTransaction: {}})

    }

    clearVarsCreateTransaction()
    {
        this.getHistoricTransactions();
        this.getWallet();
        this.divResult = '';
        this.returnTransaction = null;
        this.uniqueId = '';
        this.setState({'returnTransaction': []})
        this.setState({'loading': false})
        clearInterval(this.interval$)
        if (this.interval$)
        {
            clearInterval(this.interval$);
            clearTimeout(this.interval$);
        }
    }

    clearInfoCashManual()
    {

    }

    loadHistoricTransaction()
    {
        this.getHistoricTransactions();
    }

    //FUNCTIONS MODAL TOGGLE
    toggleModal()
    {
        if (this.state.canClose)
        {
            this.setState({ modalIsOpen: !this.state.modalIsOpen })
        }
    }

    toggleModalCashManual()
    {
        this.setState({ modalCashManualIsOpen: !this.state.modalCashManualIsOpen })
    }

    toggleModalRequestTransfer()
    {
        this.setState({ modalRequestTransferIsOpen: !this.state.modalRequestTransferIsOpen })
    }

    toggleModalPayment()
    {
        this.setState({ modalPaymentIsOpen: !this.state.modalPaymentIsOpen })
    }

    toggleModalInfoWithdrawal()
    {
        this.setState({modalInfoWithdrawal: !this.state.modalInfoWithdrawal})
    }

    toggleModalDetailsTransaction()
    {
        this.setState({modalDetailsTransaction: !this.state.modalDetailsTransaction})
    }

    //FUNCTIONS CHANGE VALUES
    async changePaymentType(paymentType)
    {
        await this.setState({paymentType: paymentType.target.value});
    }
    async changeValuePaymentManual(event, originalValue, maskedValue)
    {
        await this.setState({valueManual: originalValue});
    }

    async changeValuePayment(event, originalValue, maskedValue)
    {
        await this.setState({value: originalValue})
    }

    async changeValueRequestWithdrawal(event, originalValue, maskedValue)
    {
        await this.setState({valueRequestWithdrawal: originalValue})
    }

    async changeDescriptionManual(el)
    {
        await this.setState({descriptionManual: el.target.value})
    }


    //FUNCTION REQUESTS
    getHistoricTransactions()
    {
        const params = {
            'pageSize': this.pageSize,
            'page': this.page,
            'userId': this.establishmentId
        };

        this.clientHttp.post(this.baseUrl+'/wallets/transactions/get', params)
            .then(response => {
                const data = response.data
                this.setState({'historicTransactions': data.details.items ? data.details.items : []})
                this.setState({
                    'pagination': {
                        'totalItems': data.details.itemsTotal ? data.details.itemsTotal : 0,
                        'page': this.state.pagination.page,
                        'pageSize': this.state.pagination.pageSize,
                        'pageCount': Math.ceil(data.details.itemsTotal / this.state.pagination.pageSize)
                    }
                })
                console.error(this.state);
            })
    }

    getWallet()
    {
        this.clientHttp.get(this.baseUrl+'/wallets/'+this.establishmentId)
            .then((response) => {
                const data = response.data;

                if(data.code === 1)
                {
                    this.setState({'balance':this.currencyFormat(data.details.balance)});
                }
            });
    }

    createTransactionManual()
    {
        const params = {
            userId: this.establishmentId,
            value: this.state.valueManual,
            merchant: this.merchantManual,
            description: this.state.descriptionManual
        }

        if(params.value <= 0)
        {
            toast.warn('O valor não pode ser 0 ou menor')
            return;
        }

        this.setState({loading: true})
        this.clientHttp.post(this.baseUrl+'/wallets/transactions/create/manual', params)
            .then(response => {
                const data = response.data;
                this.setState({loading: false})

                if (data.code === 1)
                {
                    toast.success(data.message);
                    this.getWallet();
                    this.getHistoricTransactions();
                    this.toggleModalCashManual();
                }
            }).catch(error => {
                console.error(error);
                this.setState({loading: false})
            })

    }

    createTransaction()
    {
        const params = {
            userId: this.establishmentId,
            value: this.state.value,
            paymentMethod: this.state.paymentType,
        };
        if(params.value <= 0)
        {
            toast.warn('O valor não pode ser 0 ou menor')
            return;
        }

        if(params.value < 60)
        {
            toast.warn('O valor mínimo para recarga deve ser de R$60,00')
            return;
        }

        this.setState({loading: true})
        this.clientHttp.post(this.baseUrl+'/wallets/transactions/create', params)
            .then(response => {
                const data = response.data;
                console.log(data);
                if (data.code === 1)
                {
                    toast.success(data.message);
                    this.returnTransaction = data.details;
                    this.uniqueId = data.details.uniqueId;
                    this.setState({'returnTransaction': data.details})
                    toast.info('Buscando detalhes do pagamento');
                    setTimeout(() => {
                        this.getDetailsTransaction()
                    }, 3000);
                }
                else
                {
                    toast.error(data.message);
                    this.setState({loading: false})
                }
            }).catch((error) => {
                this.setState({loading: false})
                console.error(error);
            })
    }

    getDetailsTransaction() {
        const params = {
            uniqueId: this.uniqueId
        };
        this.setState({loading: true})
        this.clientHttp.post(this.baseUrl+'/wallets/transactions/getDetails', params)
            .then(response => {
                const data = response.data;
                console.log(data);
                this.setState({loading: false})
                
                if(data.code === 1)
                {
                    this.returnTransaction = data.details;

                    if (this.state.paymentType === 'pix')
                    {
                        this.divResult = <DivPixResult action={this.cancelTransactionPix} result={this.returnTransaction}/>
                        this.setState({'canClose': false});
                        this.interval$ = setInterval(() => {
                            this.getDetailsTransactionPix();
                        }, 4000)
                    }
                    else
                    {
                        this.divResult = <DivBoletoResult result={this.returnTransaction}/>
                    }
                    this.setState({'returnTransaction': data.details})
                }
                else
                {
                    this.getDetailsTransaction();
                }
            }).catch((error) => {
                this.setState({loading: false})
            })
    }

    openModalTransactionDetails(uniqueId) {
        const params = {
            uniqueId: uniqueId
        };
        this.toggleModalDetailsTransaction();
        this.setState({loading: true})
        this.clientHttp.get(this.baseUrl+'/wallets/transactions/getDetails/'+uniqueId, params)
            .then(response => {
                const data = response.data;
                this.setState({loading: false})
                if(data.code === 1)
                {
                    this.returnTransaction = data.details.transaction;

                    this.divResult = <DivBoletoResult result={this.returnTransaction}/>
                    this.setState({'returnTransaction': data.details})
                }
            }).catch((error) => {
            this.setState({loading: false})

        })
    }

    getDetailsTransactionPix()
    {
        const params = {
            uniqueId: this.uniqueId
        };
        this.clientHttp.post(this.baseUrl+'/wallets/transactions/getDetails/pix', params)
            .then(response => {
                const data = response.data;
                
                if(data.code === 1)
                {
                    this.divResult = <DivSuccessPaymentPix/>
                    this.setState({'canClose': true});
                    clearInterval(this.interval$);
                }
                else if(data.code >2)
                {
                    toast.warn(data.message);
                }
            }).catch((error) => {
                console.error(error);
                clearInterval(this.interval$);
            })
    }

    cancelTransactionPix()
    {
        swal({
            title: "Deseja CANCELAR esse pagamento?",
            text: 'Essa ação não pode ser desfeita!',
            buttons: ['Cancelar', 'Confirmar'],
        }).then((result) => {
            if (result)
            {
                const params = {
                    uniqueId: this.uniqueId
                }
                clearInterval(this.interval$);
                this.setState({'loading': true});
                this.clientHttp.post(this.baseUrl+'/wallets/transactions/cancel', params)
                    .then(response => {
                        const data = response.data;
                        this.setState({'loading': false});
                        
                        if(data.code === 1)
                        {
                            this.divResult = <DivCancelPaymentPix/>
                            this.setState({'canClose': true});
                            toast.success(data.message);
                        }
                    }).catch((error) => {
                        this.setState({'loading': false});
                    })
            }
        })
    }

    cancelTransaction(uniqueId)
    {
        swal({
            title: "Deseja CANCELAR esse transação?",
            text: 'Essa ação não pode ser desfeita!',
            buttons: ['Cancelar', 'Confirmar'],
        }).then((confirm) => {
            if (confirm)
            {
                const params = {
                    uniqueId: uniqueId
                }
                swal({
                    title: "Deseja restabelecer o sado?",
                    text: 'Essa ação não pode ser desfeita!',
                    buttons: ['Não', 'Sim'],
                }).then(result => {
                    params['returnCash'] = result;
                    swal({
                        title: "Deseja remover a taxa de recarga?",
                        text: 'Essa ação não pode ser desfeita!',
                        buttons: ['Não', 'Sim'],
                    }).then(removeTax => {
                        params['removeTax'] = removeTax;
                        clearInterval(this.interval$);
                        this.setState({'loading': true});
                        this.clientHttp.post(this.baseUrl+'/wallets/transactions/cancel', params)
                            .then(response => {
                                const data = response.data;
                                this.setState({'loading': false});
                                
                                if(data.code === 1)
                                {
                                    this.divResult = <DivCancelPaymentPix/>
                                    this.setState({'canClose': true});
                                    this.getHistoricTransactions();
                                    toast.success(data.message);
                                }
                            }).catch((error) => {
                            this.setState({'loading': false});
                        })
                    })

                })



            }
        })
    }

    requestWithdrawal()
    {
        const params = {
            user_id: this.establishmentId,
            amount: this.state.valueRequestWithdrawal,
        };

        if(params.valueRequestWithdrawal <= 0)
        {
            toast.warn('O valor não pode ser 0 ou menor')
            return;
        }

        this.clientHttp.post(this.baseUrl+'/wallets/transactions/withdrawal/request', params)
            .then(response => {
                const data = response.data;
                if (data.code === 1)
                {
                    toast.success(data.message);
                    this.toggleModalRequestTransfer();
                }
                else
                {
                    toast.warn(data.message);
                }
            })
    }

    getRequestWithdrawal()
    {
        this.clientHttp.get(this.baseUrl+'/wallets/transactions/withdrawal/request')
            .then(response => {
                const data = response.data;
                
                if (data.code === 1)
                {
                    this.setState({listRequestWithdrawal: data.details})
                }

            })
    }

    finishPaymentWithdrawal(id)
    {
        this.clientHttp.get(this.baseUrl+'/wallets/transactions/withdrawal/info/'+id)
            .then(result => {
                const data = result.data;
                let text = 'PARA: ' + data.details.name + '\n\n VALOR: ' + this.currencyFormat(parseFloat(data.details.amount)) + '\n\n PIX: ' + (data.details.pix ? data.details.pix : 'PIX NÃO ENCONTRADO');

                swal({
                    title: "Deseja Realizar esse pagamento?",
                    text: text,
                    buttons: ['Cancelar', 'Confirmar'],
                }).then((result => {
                        
                        if(result)
                        {
                            const params = {
                                userPaymentId: this.user_id,
                                transactionId: id
                            };
                            this.clientHttp.post(this.baseUrl+'/wallets/transactions/withdrawal/finish', params)
                                .then(response => {
                                    const data = response.data;
                                    
                                    if (data.code === 1)
                                    {
                                        toast.success(data.message);
                                        this.getRequestWithdrawal();
                                    }
                                    else if (data.code === 3)
                                    {
                                        toast.warn(data.message);
                                    }
                                    else
                                    {
                                        toast.error(data.message);
                                    }
                                })
                        }

                    })
                );
            })
    }

    async getMerchants(el)
    {
        const query = el.target.value;
        this.clientHttp.get(this.baseUrl+'/merchants/query/'+query)
            .then(response => {
                const data = response.data;
                
                if (data.code === 1)
                {
                    this.setState({merchants: data.details ? data.details : []})
                }
            })
    }

    async selectMerchant(el)
    {

        const merchantSelect = this.state.merchants.filter((v) => {
            if (v.name === el.target.value)
                return v;
        })[0]

        this.merchantManual = merchantSelect;
    }

    InputMerchants()
    {
        return (
            <div>
                <label>Estabelecimento</label>
                <input type="text" className="form-control" list="merchants_list"
                       onInput={this.selectMerchant} onKeyUp={this.getMerchants}/>

                <datalist id="merchants_list">
                    {
                        this.state.merchants ? this.state.merchants.map(item => {
                            return (
                                <option value={item.name} id={item.id}>{item.name}</option>
                            )
                        }) : ''
                    }
                </datalist>
            </div>
        );
    }

    //RENDER HTML
    render()
    {
        return (
            <div>
                <Modal
                    isOpen={this.state.modalCashManualIsOpen}
                    toggle={this.toggleModalCashManual}
                    ariaHideApp={false}
                    onAfterClose={this.clearInfoCashManual}
                >
                    <div className="modal-header">
                        <h3 className="font-bold">Adicionar Crédito Manualmente</h3>
                        <button
                            className="btn-close-header"
                            onClick={this.toggleModalCashManual}
                        >
                            X
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="form-group">
                            <label className="h4 font-bold">Valor</label>
                            <IntlCurrencyInput
                                className="form-control"
                                currency="BRL"
                                config={currencyConfig}
                                onChange={this.changeValuePaymentManual}
                            />
                        </div>

                        <div className="form-group">
                            {this.isSuperUser === 'true' ? this.InputMerchants() : ''}

                        </div>

                        <div className="form-group">
                            <label>Descrição</label>
                            <input type="text" className="form-control" onChange={this.changeDescriptionManual}/>
                        </div>

                    </div>


                    <div className="modal-footer">
                        <button
                            className="btn btn-success"
                            onClick={this.createTransactionManual}
                        >
                            Adicionar
                        </button>
                        <button
                            className="btn btn-danger"
                            onClick={this.toggleModalCashManual}
                        >
                            Fechar
                        </button>
                    </div>

                </Modal>

                {/*MODAL DETALHES DA TRANSAÇÃO*/}
                <Modal
                    isOpen={this.state.modalDetailsTransaction}
                    toggle={this.toggleModalDetailsTransaction}
                    ariaHideApp={false}
                    onAfterClose={this.clearDetailsTransaction}
                >
                    <div className="modal-header">
                    <h3 className="font-bold">Detalhes Fatura</h3>
                        <button
                            className="btn-close-header"
                            onClick={this.toggleModalDetailsTransaction}
                        >
                            X
                        </button>
                    </div>

                    <div className='modal-body'>
                        <div className="box-transaction-details">
                            {this.state.loading ? <DivLoading/> : ''}
                            {this.divResult}
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            className="btn btn-danger"
                            onClick={this.toggleModalDetailsTransaction}
                        >
                            Fechar
                        </button>
                    </div>
                </Modal>


                {/*MODAL SOLICITAÇÃO DE SAQUE*/}
                <Modal
                    isOpen={this.state.modalRequestTransferIsOpen}
                    toggle={this.toggleModalRequestTransfer}
                    ariaHideApp={false}
                    onAfterClose={this.loadHistoricTransaction}
                >
                    <div className="modal-header">
                        <h3 className="font-bold">Solicitar Saque</h3>
                        <button
                            className="btn-close-header"
                            onClick={this.toggleModalRequestTransfer}
                        >
                            X
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="form-group">
                            <label className="h4 font-bold">Valor</label>
                            <IntlCurrencyInput
                                className="form-control"
                                currency="BRL"
                                config={currencyConfig}
                                onChange={this.changeValueRequestWithdrawal}
                            />
                        </div>

                        <div className="form-group">
                            <button
                                className="btn btn-success h3"
                                onClick={this.requestWithdrawal}
                            >
                                Solicitar Valor
                            </button>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            className="btn btn-danger"
                            onClick={this.toggleModalRequestTransfer}
                        >
                            Fechar
                        </button>
                    </div>
                </Modal>

                {/*MODAL ADICIONAL SALDO*/}
                <Modal
                    isOpen={this.state.modalIsOpen}
                    toggle={this.toggleModal}
                    ariaHideApp={false}
                    onAfterClose={this.clearVarsCreateTransaction}
                >
                    <div className="modal-header">
                        <h3 className="font-bold">Adicionar Saldo</h3>
                        {this.state.canClose
                            ?
                            <button
                                className="btn-close-header"
                                onClick={this.toggleModal}
                            >
                                X
                            </button>
                            :
                            ''
                        }
                    </div>

                    <div className="modal-body">
                        <div className="form-group">
                            <label className="h4 font-bold">Valor</label>
                            <IntlCurrencyInput
                                className="form-control"
                                currency="BRL"
                                config={currencyConfig}
                                onChange={this.changeValuePayment}
                        />
                            <small>O valor deve ser maior que R$ 60,00</small>
                        </div>
                    <div className="form-group">
                        <label className="h4 font-bold">Forma de Pagamento</label>
                        <div className="form-group-checkbox">
                            <input
                                type="radio"

                                id="paymentTypePix"
                                value="pix"
                                checked={this.state.paymentType === 'pix'}
                                onChange={this.changePaymentType}
                            />
                            <label htmlFor="paymentTypePix">PIX</label>
                        </div>
                        {/*<div className="form-group-checkbox">
                            <input
                                type="radio"
                                id="paymentTypeBoleto"
                                value="boleto"
                                checked={this.state.paymentType === 'boleto'}
                                onChange={this.changePaymentType}
                            />
                            <label className="font-bold" htmlFor="paymentTypeBoleto">Boleto</label>
                        </div>*/}
                    </div>

                    <div className="form-group">
                        <button
                            className="btn btn-success h3"
                            onClick={this.createTransaction}
                        >
                            Gerar
                        </button>
                    </div>

                    <div className="box-transaction-details">
                        {this.state.loading ? <DivLoading/>: ''}
                        {this.divResult}
                    </div>

                </div>


                <div className="modal-footer">
                    {this.state.canClose
                        ?
                        <button
                            className="btn btn-danger"
                            onClick={this.toggleModal}
                        >
                            Fechar
                        </button>
                        :
                        ''
                    }
                </div>
                </Modal>

                {/*MODAL REALIZAR PAGAMENTOS*/}
                <Modal
                    isOpen={this.state.modalPaymentIsOpen}
                    toggle={this.toggleModalPayment}
                    ariaHideApp={false}
                    onAfterOpen={this.getRequestWithdrawal}
                >

                    <div className="modal-header">
                        <h3 className="font-bold">Realizar Pagamentos</h3>
                        <button
                            className="btn-close-header"
                            onClick={this.toggleModalPayment}
                        >
                            X
                        </button>
                    </div>

                    <div className="modal-body">
                        <table className='table table-striped'>
                            <thead>
                            <tr>
                                <td>ID</td>
                                <td>Motoboy</td>
                                <td>Valor</td>
                                <td>Descrição</td>
                                <td>Status</td>
                                <td>Data Solicitação</td>
                                <td></td>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.listRequestWithdrawal.length > 0 ? this.state.listRequestWithdrawal.map((data, i) => (
                                        <tr key={i}>
                                            <td>{data.wallet_transaction_id}</td>
                                            <td>{data.name}</td>
                                            <td>{this.currencyFormat(data.amount)}</td>
                                            <td>{data.description}</td>
                                            <td>{data.status}</td>
                                            <td>{this.formatDate(data.date_created)}</td>
                                            <td>
                                                <button
                                                    className='btn btn-dark'
                                                    onClick={() => {this.finishPaymentWithdrawal(data.wallet_transaction_id)}}
                                                >
                                                    Pagar
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    (<tr>
                                        <td colSpan={6}>Não existe registros</td>
                                    </tr>)
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className="modal-footer">
                        <button
                            className="btn btn-danger"
                            onClick={this.toggleModalPayment}
                        >
                            Fechar
                        </button>
                    </div>
                </Modal>

                {/*MODAL INFORMAÇÕES E FINALIZAÇÃO DO SAQUE*/}
                <Modal
                    isOpen={this.state.modalInfoWithdrawal}
                    toggle={this.toggleModalInfoWithdrawal}
                    ariaHideApp={false}
                    className="modal-info-withdrawal"
                >
                    <div className="modal-header">
                        <h3 className="font-bold">Realizar Pagamentos</h3>
                        <button
                            className="btn-close-header"
                            onClick={this.toggleModalInfoWithdrawal}
                        >
                            X
                        </button>
                    </div>


                    <div className="modal-footer">
                        <button
                            className="btn btn-danger"
                            onClick={this.toggleModalInfoWithdrawal}
                        >
                            Fechar
                        </button>
                    </div>
                </Modal>

                <BarTitle name={"Carteira"}></BarTitle>
                <div className="wrapper-md">
                    <Painel title="Carteira">
                        <div className="container-saldo">
                            <div className="box-saldo">
                                <h2>Saldo: </h2>
                                <h2>{this.state.balance}</h2>
                            </div>

                            <div className="box-add-saldo">

                                <a
                                    href="/#/home/wallet/reports"
                                    className="btn btn-primary"
                                >
                                    Relatórios
                                </a>

                                {this.isDriver ?
                                    (<button
                                            type="button"
                                            className="request-cash"
                                            onClick={this.toggleModalRequestTransfer}
                                        >
                                            Solicitar Saque
                                        </button>
                                    )
                                    :
                                    <button
                                        type="button"
                                        className="add-cash"
                                        onClick={this.toggleModal}
                                    >
                                        Adicionar Crédito
                                    </button>
                                }
                                {
                                    this.isSuperUser === 'true' ?(<button
                                        type="button"
                                        className="add-cash-manual"
                                        onClick={this.toggleModalCashManual}
                                    >
                                        Crédito Manual
                                    </button>) : ''
                                }
                                {/*{
                                    !this.isDriver ?
                                        <button
                                            type="button"
                                            className="confirm-withdrawal"
                                            onClick={this.toggleModalPayment}
                                        >
                                            Realizar Pagamento
                                        </button>
                                        :
                                        ''
                                }*/}

                            </div>
                        </div>
                    </Painel>


                    <Painel title="Histórico de Transações">
                        <div className="">
                            <table className='table table-striped'>
                                <thead>
                                <tr>
                                <td>ID</td>
                                    <td>Unique ID</td>
                                    {this.isSuperUser === 'true' ? (<td>Estabelecimento</td>) : ''}
                                    <td>Valor</td>
                                    {this.isSuperUser === 'true' ? (<td>Taxa de Recarga</td>) : ''}
                                    <td>Descrição</td>
                                    <td>Status</td>
                                    <td>Forma de Pagamento</td>
                                    <td>Data Criação</td>
                                    {this.isSuperUser === 'true' ? (<td></td>) : ''}
                                </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.historicTransactions.length > 0 ? this.state.historicTransactions.map((data, i) => (
                                    <tr key={i}>
                                        <td>{data.wallet_transaction_id}</td>
                                        <td>{data.unique_id}</td>
                                        {this.isSuperUser === 'true' ? (<td>{data.merchantName}</td>) : ''}
                                        <td>{this.currencyFormat(data.amount)}</td>
                                        {this.isSuperUser === 'true' ? (<td>{this.currencyFormat(data.tax_amount)}</td>) : ''}
                                        <td>{data.description}</td>
                                        <td>{data.status}</td>
                                        <td>{data.payment_method ? data.payment_method.toUpperCase() : ''}</td>
                                        <td>{this.formatDate(data.date_created)}</td>
                                        {/*<td>
                                            {
                                                (data.payment_method && data.payment_method.toLowerCase() === 'boleto')
                                                ?
                                                <button onClick={() => {
                                                    this.openModalTransactionDetails(data.unique_id)
                                                }} className="btn btn-default">
                                                    Ver Fatura
                                                </button>
                                                :
                                                " "
                                            }
                                        </td>*/}
                                        {this.isSuperUser === 'true' && data.status !== 'Cancelado' ? (<button className="btn btn-sm btn-danger" title="Cancelar Transação" onClick={() => {this.cancelTransaction(data.unique_id)}}>X</button>) : ''}
                                    </tr>
                                ))
                                    :
                                    (<tr><td colSpan={8}>Não existe registros</td></tr>)
                            }
                            </tbody>
                        </table>


                    </div>
                </Painel>
            </div>
        </div>
        );
    }
}

export default Wallet;



// WEBPACK FOOTER //
// ./src/views/Wallet/index.js